import { css } from "emotion";
import CMSComponent from "../../../components/CMSComponent";
import H2 from "../../../components/global/H2";
import P from "../../../components/global/P";
import Banner from "../../../components/layout/Banner";
import Layout from "../../../components/layout/Layout";
import { updateTitle } from "../../../utils/BrowserUtils";
import DescriptionBlock from "../DescriptionBlock";
import Flag from "./componets/Flag";
import HowToHelp from "./componets/HowToHelp";
import HowWeDeliver from "./componets/HowWeDeliver";
import OurImpacts from "./componets/OurImpacts";
import ProjectDeliveryPartners from "./componets/ProjectDeliveryPartners";
import Quote from "./componets/Quote";
import { max } from "../../../utils/CssUtils";

const bannerImage = require("../../../assets/Projects/RoomToReadBanner.png");
const quoteImage = require("../../../assets/Projects/Ban_Moon.png");
const r2rLogo = require("../../../assets/Projects/r-2-r-logo.svg");
const icMentorship = require("../../../assets/Projects/ic_mentorship.svg");
const icMaterialSupport = require("../../../assets/Projects/ic_material_support.svg");

const descImage = require("../../../assets/Projects/Room2Read.png");

const bannerContent = css({
  padding: "0px 0px 0px 80px",
  textAlign: "left",
  h2: {
    maxWidth: 402,
    marginBottom: 16,
    fontSize: 36
  },
  p: {
    maxWidth: 402,
    marginBottom: 20,
    marginLeft: 0,
    fontSize: 18
  },
  "@media(max-width: 1080px)": {
    padding: "112px 0px 24px 80px"
  },
  "@media(max-width: 768px)": {
    padding: "40px 14px 24px 14px",
    h2: {
      fontSize: 22
    },
    p: {
      fontSize: 16
    }
  }
});

const ourImpactData = [
  {
    title: "Every ticket counts",
    content: "$1 = 1 day",
    subtext: "of education for a child"
  },
  {
    title: "Our impact",
    content: "52,000",
    subtext: "days of education"
  },
  {
    title: "Our target",
    content: "100 million",
    subtext: "days of education by 2030"
  }
];

const howWeDeliverScholarships = [
  {
    image: icMaterialSupport,
    alt: "material support icon",
    title: "Material support",
    content:
      "For some families, the cost of a school uniform or safe transportation is prohibitive to sending their daughters to school. We provide need-based material support for school costs such as tuition fees, uniforms and exam preparation services so parents don’t have to make the choice between putting food on the table and investing in education."
  },
  {
    image: icMentorship,
    alt: "Mentorship icon",
    title: "Mentorships",
    content:
      "Local women are hired as mentors and work with girls and their families to ensure that girls stay in school, participate in life skills activities, and navigate the challenges of adolescence with the ability and confidence to make their own life choices and voice their opinion."
  }
];

const explanation = [
  `The single best approach to improving the status of women in
  emerging economies is through education. Studies have shown that
  educated women are more likely to have smaller and healthier
  families, and higher wages. They are also more likely to marry
  later and educate their own children — ending the cycle of
  illiteracy in one generation.`,
  `Yet, girls are disadvantaged when it comes to education. Cultural
  bias, gender discrimination and safety concerns discourage girls
  from learning, and these pressures become more pronounced when
  girls reach secondary school.`
];

const RoomToRead = ({ localeData }) => {
  updateTitle("Room To Read");
  //banner information
  const consoleUrl =
    localeData && localeData.consoleURL ? localeData.consoleURL : "";

  return (
    <Layout>
      <Banner image={bannerImage} bgColor="greyBackground">
        <div className={bannerContent}>
          <H2>Girls’ Education Programs</H2>
          <P>
            “Investing in girls’ education is the very best thing we can do, not
            just for our daughters and granddaughters, but for their families,
            their communities, and their countries.” <b>- Michelle Obama</b>{" "}
          </P>
        </div>
      </Banner>

      <OurImpacts data={ourImpactData} />

      <DescriptionBlock
        heading="Keeping girls in school so they can reach their potential"
        alt="Girls in the classroom learning to read via non-profite room to read literacy program"
        image={descImage}
        text={explanation}
      />

      <HowWeDeliver
        header="How we deliver our girl’s education program"
        data={howWeDeliverScholarships}
      />

      <HowToHelp
        localeData={localeData}
        text="We’re a unique charity, in that we don’t ask for donations (though you are welcome to offer). "
      />

      <ProjectDeliveryPartners>
        <P>
          We believe in impact with evidence, not just good intentions. That’s
          why we work with expert delivery partners, to make sure all our
          projects are making long lasting, systemic change.
        </P>
        <Flag>
          <img
            src={r2rLogo}
            alt="Room to Read Logo: non-profit focused on girls' education"
          />
          <P>
            Our girl’s education program is delivered in Nepal, India, Cambodia
            and others with our delivery partner, Room To Read.
          </P>
        </Flag>
        <Quote
          image={quoteImage}
          imageAlt="Picture of south Korean statesman and secretary-general of the United Nations, Ban Ki-Moon."
          quote="“Education is not just for a privileged few, it is for everyone. 
          It is a fundamental human right.”"
          author="Ban Ki-Moon"
        />
      </ProjectDeliveryPartners>
    </Layout>
  );
};

export default CMSComponent(null, RoomToRead);
